export const variableTypes = {
    COMPANY_VARIABLE: 'COMPANY_VARIABLE',
    MEASURE: 'MEASURE',
    COMPANY_ACCOUNT_GROUP: 'COMPANY_ACCOUNT_GROUP',
    COMPANY_ACCOUNT: 'COMPANY_ACCOUNT',
    INDICATOR: 'INDICATOR'
};